import React, { useState } from 'react';
import { companyInfo } from './mock';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Email will be sent via backend
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <div className="w-full">
      {/* Header */}
      <section className="bg-gradient-to-br from-teal-50 via-white to-cyan-50 py-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">Contact Us</h1>
          <p className="text-xl text-gray-600">Have questions? We're here to help you with your testing needs.</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-6 mb-16">
            {/* Contact Cards */}
            <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-lg border border-gray-100 hover:shadow-lg transition">
              <div className="bg-teal-100 w-14 h-14 rounded-lg flex items-center justify-center mb-4">
                <Mail className="w-7 h-7 text-teal-600" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Email</h3>
              <p className="text-teal-600 font-medium mb-2">{companyInfo.email}</p>
              <p className="text-sm text-gray-500">Typically respond within 24 hours</p>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-lg border border-gray-100 hover:shadow-lg transition">
              <div className="bg-teal-100 w-14 h-14 rounded-lg flex items-center justify-center mb-4">
                <Phone className="w-7 h-7 text-teal-600" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Phone</h3>
              <p className="text-teal-600 font-medium mb-2">{companyInfo.phone}</p>
              <p className="text-sm text-gray-500">Mon-Fri, 9 AM - 6 PM IST</p>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-lg border border-gray-100 hover:shadow-lg transition">
              <div className="bg-teal-100 w-14 h-14 rounded-lg flex items-center justify-center mb-4">
                <MapPin className="w-7 h-7 text-teal-600" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Address</h3>
              <p className="text-teal-600 font-medium text-sm mb-2">{companyInfo.address}</p>
              <p className="text-sm text-gray-500">Visit during working hours</p>
            </div>
          </div>

          {/* Contact Form and Info */}
          <div className="grid md:grid-cols-2 gap-8">{/* Form */}
            <div className="bg-white p-8 rounded-lg border border-gray-200">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Send us a Message</h2>
              <p className="text-gray-600 mb-6">Fill out the form and we'll respond as soon as possible.</p>
              <form onSubmit={handleSubmit} className="space-y-5">{submitted && (
                  <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg mb-4">
                    ✓ Thank you! We'll get back to you soon.
                  </div>
                )}

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Full Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent outline-none transition"
                    placeholder="Enter your name"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Email Address</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent outline-none transition"
                    placeholder="your@email.com"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent outline-none transition"
                    placeholder="+91 XXXXX XXXXX"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Subject</label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent outline-none transition"
                    placeholder="Message subject"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Message</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="4"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent outline-none transition resize-none"
                    placeholder="Your message here..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-teal-600 text-white py-3 rounded-lg font-bold hover:bg-teal-700 transition"
                >
                  Send Message
                </button>
              </form>
            </div>

            {/* Info */}
            <div>
              <div className="bg-gradient-to-br from-teal-600 to-cyan-600 text-white p-10 rounded-lg">
                <h2 className="text-2xl font-bold mb-8">Contact Information</h2>
                
                <div className="space-y-6 mb-8">
                  <div className="flex items-start">
                    <Mail className="w-5 h-5 mr-4 flex-shrink-0 mt-1" />
                    <div>
                      <p className="text-teal-100 text-sm mb-1">Email</p>
                      <p className="font-semibold">{companyInfo.email}</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <Phone className="w-5 h-5 mr-4 flex-shrink-0 mt-1" />
                    <div>
                      <p className="text-teal-100 text-sm mb-1">Phone</p>
                      <p className="font-semibold">{companyInfo.phone}</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <MapPin className="w-5 h-5 mr-4 flex-shrink-0 mt-1" />
                    <div>
                      <p className="text-teal-100 text-sm mb-1">Address</p>
                      <p className="font-semibold text-sm">{companyInfo.address}</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <Clock className="w-5 h-5 mr-4 flex-shrink-0 mt-1" />
                    <div>
                      <p className="text-teal-100 text-sm mb-1">Working Hours</p>
                      <p className="font-semibold text-sm">{companyInfo.workingHours}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 p-8 rounded-lg mt-6 border border-gray-200">
                <h3 className="font-bold text-gray-900 mb-6 text-lg">Quick Answers</h3>
                <div className="space-y-5">
                  <div>
                    <p className="font-semibold text-gray-900 mb-2">How long does testing take?</p>
                    <p className="text-gray-700 text-sm">Pashmina: 3-5 days | Adulteration: 5-7 days</p>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 mb-2">Response time?</p>
                    <p className="text-gray-700 text-sm">Within 24 hours on working days.</p>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 mb-2">Walk-ins allowed?</p>
                    <p className="text-gray-700 text-sm">Yes, but appointments recommended for best service.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
